<!-- invitation-preview.component.html -->
@if (loading) {
  <div class="flex justify-center py-8">
    <span class="loading loading-spinner loading-md" aria-label="Loading"></span>
  </div>
}

@if (error && !loading) {
  <ui-alert [variant]="'error'" className="my-4">
    {{ error }}
  </ui-alert>
}

@if (!loading && preview) {
  <ui-card className="max-w-6xl mx-auto" [shadow]="false" [bordered]="true">
    <div class="flex items-center justify-between gap-4">
      <h1 class="text-lg font-semibold">You’ve been invited</h1>

      <ui-badge [variant]="preview.valid ? 'success' : 'neutral'">
        {{ preview.valid ? 'Valid' : 'Unavailable' }}
      </ui-badge>
    </div>

    <div class="divider my-2"></div>

    <div class="space-y-3">
      <div class="flex items-start justify-between gap-6">
        <span class="text-base-content/70">Invited by</span>
        <span class="font-semibold break-all text-right">{{ preview.inviter_email }}</span>
      </div>

      <div class="flex items-start justify-between gap-6">
        <span class="text-base-content/70">For</span>
        <span class="font-semibold text-right">{{ preview.household_name }}</span>
      </div>

      <div class="flex items-start justify-between gap-6">
        <span class="text-base-content/70">Invitee</span>
        <span class="break-all text-right">{{ preview.invitee_email }}</span>
      </div>

      <div class="flex items-start justify-between gap-6">
        <span class="text-base-content/70">Expires</span>
        <span class="text-right">
          @if (preview.valid) {
            in <span class="font-semibold">{{ preview.expires_in_days }}</span> days
          } @else {
            expired
          }
        </span>
      </div>
    </div>

    <div class="divider my-4"></div>

    <div class="flex sm:flex-row gap-2 justify-end">
      <ui-button
        [variant]="'danger'"
        [outline]="decision !== 'reject'"
        [disabled]="!preview?.valid"
        (clicked)="onReject()"
      >
        Reject
      </ui-button>

      <ui-button
        [variant]="'success'"
        [outline]="decision !== 'accept'"
        [disabled]="!preview?.valid"
        (clicked)="onAccept()"
      >
        Accept
      </ui-button>
    </div>
  </ui-card>
}
